/**
 * Explicit, fixed document metadata. Never derived from the project or prompt
 * name — these values are the source of truth and are re-applied on load.
 */
export const PAGE_TITLE = 'Lentic — Assessment for AI-assisted work'

export const PAGE_DESCRIPTION =
  'Lentic runs candidates through an instrumented task where the AI is provided but the source documents are withheld, then produces the auditable record of how each person exercised judgement.'

/** The lockup on the off-white brand background, used as the share image. */
export const SHARE_IMAGE =
  'https://cdn.magicpatterns.com/uploads/rkUg1vBYDJdeiRNyrhAJx9/image.png'

/** The ripple mark redrawn as vector: deep teal on transparent. */
const FAVICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none">
<g stroke="#12564f" stroke-width="3.4" stroke-linecap="round">
<path d="M40.55 15.13A21 21 0 1 1 24 3"/>
<path d="M32.4 15.6A15 15 0 1 1 24 9"/>
<path d="M33.9 32.4A15 15 0 0 0 37 25.6"/>
<path d="M28.5 31.6A10.3 10.3 0 1 1 24 13.7"/>
<path d="M29.6 15.9A10.3 10.3 0 0 1 32.5 20"/>
<path d="M28.8 26.4A5.3 5.3 0 1 1 27.5 19.4"/>
</g>
<circle cx="24" cy="24" r="2.6" fill="#12564f"/>
</svg>`

function upsertMeta(key: 'name' | 'property', value: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${key}="${value}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(key, value)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function upsertIcon(rel: string, href: string, type?: string) {
  document.head
    .querySelectorAll(`link[rel="${rel}"]`)
    .forEach((node) => node.parentElement?.removeChild(node))

  const link = document.createElement('link')
  link.setAttribute('rel', rel)
  if (type) link.setAttribute('type', type)
  link.setAttribute('href', href)
  document.head.appendChild(link)
}

export function applyDocumentMetadata() {
  document.title = PAGE_TITLE
  document.documentElement.lang = 'en-GB'

  upsertMeta('name', 'description', PAGE_DESCRIPTION)

  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:site_name', 'Lentic')
  upsertMeta('property', 'og:title', PAGE_TITLE)
  upsertMeta('property', 'og:description', PAGE_DESCRIPTION)
  upsertMeta('property', 'og:image', SHARE_IMAGE)

  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', PAGE_TITLE)
  upsertMeta('name', 'twitter:description', PAGE_DESCRIPTION)
  upsertMeta('name', 'twitter:image', SHARE_IMAGE)

  upsertMeta('name', 'theme-color', '#f4f1ea')

  const favicon = `data:image/svg+xml,${encodeURIComponent(FAVICON_SVG)}`
  upsertIcon('icon', favicon, 'image/svg+xml')
  upsertIcon('apple-touch-icon', favicon)
}
